module.exports = __webpack_public_path__ + "img/toplogo-infopage.37d40880.png";